import Route from '@ember/routing/route';
import Changeset from 'ember-changeset';

export default class MailchimpConnectedToFundRoute extends Route {
  model() {
    let model = this.modelFor('funds.fund.more.mailchimp');
    let mailchimpFundSetting = model.mailchimpSetting.fundSettings.firstObject;
    let mailchimpFundSettingChangeset = new Changeset(mailchimpFundSetting);

    return {
      ...model,
      mailchimpFundSetting,
      mailchimpFundSettingChangeset,
    };
  }
}
